/* eslint-disable max-len */
import ct from "class-types.macro";
import React, { Fragment } from "react";
import { BrandSummary } from "~/common/Store/models/Brand";

interface Props {
  brands: BrandSummary[];
  mainHeading?: string;
}

const OurBrands = ({ brands }: Props) => {
  // Returns an array with arrays of the given size.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chunkArray = (myArray: any[], chunkSize: number) => {
    const results = [];

    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize));
    }

    return results;
  };
  const brandsPerRow = 2;
  const groupsOfBrands = chunkArray(brands, brandsPerRow);

  return (
    <div className="container">
      <div className={ct("my-8", "text-gray-800")}>
        <div className={ct("flex", "items-center", "justify-between", "mb-3")}>
          <h1 className={ct("mb-0", "uppercase")}>Our Brands</h1>
          <a className="btn btn-small btn-info" href="/vendors.html">
            Shop All Vendors
          </a>
        </div>
        <p data-testid="overview" className={ct("font-medium")}>
          WebstaurantStore&apos;s brands are designed to save you both time and
          money through unbeatable values on everything from elegant tabletop
          dinnerware and economy chafing dishes to heavy duty restaurant
          equipment and ware washing chemicals. Browse through our brands to
          explore everything we bring to you from exclusive brands available
          only through WebstaurantStore.
        </p>
      </div>
      <div id="page" className="showcase clears">
        <div id="main">
          {groupsOfBrands.map((brandGroup, GrpIndex) => (
            <div className="clears brandBox" key={String(GrpIndex)}>
              {brandGroup.map((brand, index) => (
                <Fragment key={brand.name}>
                  <div className="box">
                    <div className="my-auto brandImage pull-left">
                      <a
                        href={brand.link}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <img src={brand.image} alt={brand.name} />
                      </a>
                    </div>
                    <div className="brandContent pull-left">
                      <h2>{brand.nameWithTrademark}</h2>
                      <p>{brand.ourBrandText}</p>
                      <a
                        href={brand.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="btn btn-small btn-info"
                      >{`Shop ${brand.name}`}</a>
                    </div>
                  </div>
                  {index % 2 === 0 && <span />}
                </Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>
      <p
        className={ct(
          "text-base",
          "text-gray-800",
          "-mt-2.5",
          "-mb-6",
          "px-1",
          "xs:px-0"
        )}
      >
        The above list is a current, but not exhaustive, list of trademarks
        owned by Clark Core Services, LLC or its affiliates
        (&#8220;Clark&#8221;). The absence of a trademark from this list is not
        a waiver of Clark&#8217;s rights in that mark, does not indicate that
        Clark does not use the mark, nor does it mean that a product or service
        is not actively marketed or is not significant. Those trademarks
        followed by &#174; are registered trademarks in the United States.
      </p>
    </div>
  );
};

export default OurBrands;
